import { IconName } from '@spotted-zebra-uk/ui-components';
import { ProjectCandidateStageCategory } from 'generated/graphql';

/**
 * The stage types the roles list shows, in the order both the Stages column and
 * the Candidates tooltip list them.
 */
export const STAGE_CATEGORY_ORDER = [
  ProjectCandidateStageCategory.ShortlistStage,
  ProjectCandidateStageCategory.OnlineAssessment,
  ProjectCandidateStageCategory.AiInterview,
  ProjectCandidateStageCategory.InterviewStage,
  ProjectCandidateStageCategory.ContentStage,
  ProjectCandidateStageCategory.OfferStage,
  ProjectCandidateStageCategory.NotInAStage,
] as const;

/**
 * The Stages column counts the role's own stages, so it leaves out the two
 * categories that only ever describe where a candidate is: an Offer stage is
 * never shown as a stage on the role, and "not in a stage" is not a stage.
 */
export const STAGES_COLUMN_CATEGORIES = [
  ProjectCandidateStageCategory.ShortlistStage,
  ProjectCandidateStageCategory.OnlineAssessment,
  ProjectCandidateStageCategory.AiInterview,
  ProjectCandidateStageCategory.InterviewStage,
  ProjectCandidateStageCategory.ContentStage,
] as const;

export const STAGE_CATEGORY_LABELS: Record<
  ProjectCandidateStageCategory,
  string
> = {
  [ProjectCandidateStageCategory.ShortlistStage]: 'AI shortlist',
  [ProjectCandidateStageCategory.OnlineAssessment]: 'Online assessment',
  [ProjectCandidateStageCategory.AiInterview]: 'AI interview',
  [ProjectCandidateStageCategory.InterviewStage]: 'Interview',
  [ProjectCandidateStageCategory.ContentStage]: 'Content',
  [ProjectCandidateStageCategory.OfferStage]: 'Offer',
  [ProjectCandidateStageCategory.NotInAStage]: 'Not in a stage',
};

/**
 * Offer uses the same icon and green the Role Wizard gives its Offer stage, so
 * the two surfaces read as the same thing. Only "not in a stage" has no icon —
 * it is the absence of a stage, so it renders as a plain neutral dot.
 */
export const STAGE_CATEGORY_ICONS: Partial<
  Record<ProjectCandidateStageCategory, IconName>
> = {
  [ProjectCandidateStageCategory.ShortlistStage]: 'ai',
  [ProjectCandidateStageCategory.OnlineAssessment]: 'analytics',
  [ProjectCandidateStageCategory.AiInterview]: 'ai',
  [ProjectCandidateStageCategory.InterviewStage]: 'chat',
  [ProjectCandidateStageCategory.ContentStage]: 'video_library',
  [ProjectCandidateStageCategory.OfferStage]: 'offer_stage',
};

/**
 * Only online assessments and AI interviews record completion, so only their
 * rows carry a "Completed N" line.
 */
export const STAGE_CATEGORIES_WITH_COMPLETION: ProjectCandidateStageCategory[] =
  [
    ProjectCandidateStageCategory.OnlineAssessment,
    ProjectCandidateStageCategory.AiInterview,
  ];
